<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { EditorState } from '@common/Common';
    import { SurveyEditorDialogViewModel } from "@Evaluation/CriteriaSurveys/Components/SurveyEditorDialog";

    @Component({
        props: {
            viewModel: { type: Object, required: true }
        },
        watch: {
            state: 'onEditorStateChanged'
        }
    })
    export default class SurveyEditorDialog extends Vue
    {
        get vm(): SurveyEditorDialogViewModel { return this.$props.viewModel as SurveyEditorDialogViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }

        get state() { return this.vm.editorState; }
        get title() { return this.vm.editorTitle; }
        get nameError() { return this.vm.nameError; }

        get responseDueDate(): string | null { return this.vm.responseDueDate; }
        set responseDueDate(val: string | null ) { this.vm.responseDueDate = val; }

        Initialized: boolean = false;

        SurveyId: number = null;
        Name: string = null;
        Description: string = null;

        //@Watch('state')
        onEditorStateChanged(val: EditorState, oldVal: EditorState)
        {
            if (val === EditorState.Closed)
            {
                this.Initialized = false;
            }
            else
            {
                this.vm.clearValidationErrors();
                this.SurveyId = this.vm.surveyId;
                this.Name = this.vm.surveyName;
                this.Description = this.vm.surveyDescription;

                this.Initialized = true;
            }
        }

        CreateCommand()
        {
            this.vm.clearValidationErrors();
            this.$emit('create-survey', this.SurveyId, this.Name, this.Description, this.responseDueDate);
        }

        UpdateCommand()
        {
            this.vm.clearValidationErrors();
            this.$emit('update-survey', this.SurveyId, this.Name, this.Description, this.responseDueDate);
        }

        DeleteCommand()
        {
            this.$emit('delete-survey', this.SurveyId);
        }

        close()
        {
            this.vm.close();
        }
    }

</script>

<template>
    <div class="modal-mask" v-if="state !== 'Closed'">
        <div class="modal-wrapper">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{title}}</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <h2 v-if="Initialized === false">
                            <i class="fa fa-spinner fa-spin"></i> Loading...
                        </h2>
                        <div v-if="Initialized">
                            <div class="form-group">
                                <label>Name</label>
                                <input type="text" v-model.trim="Name" class="form-control">
                                <div class="error">{{nameError}}</div>
                            </div>
                            <div class="form-group">
                                <label>Description</label>
                                <textarea type="text" v-model.trim="Description" class="form-control"></textarea>
                            </div>
                            <div class="form-group">
                                <label>Response due date:</label>
                                <input type="date" class="form-control" v-model="responseDueDate" />
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer justify-content-between">

                        <div class="dropdown dropup">
                            <button v-if="state === 'Editor'" type="button" class="btn btn-danger" data-toggle="dropdown">Delete</button>
                            <div class="dropdown-menu" role="menu" style="padding: 10px;">
                                <a class="dropdown-item">Cancel</a>
                                <a class="dropdown-item" @click="DeleteCommand">Confirm</a>
                            </div>
                        </div>

                        <div>
                            <button v-if="state === 'Creator'" @click="CreateCommand" type="button" class="btn btn-primary">Create</button>
                            <button v-if="state === 'Editor'" @click="UpdateCommand" type="button" class="btn btn-primary">Save</button>
                            <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>

</style>